export default __webpack_public_path__ + "static/media/03.14fdea1e.mp3";